import React from 'react';
import {classes, st} from './SkeletonLineWrapper.st.css';
import {SkeletonLine} from '@wix/wix-ui-tpa/cssVars';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../domain/specs';

type SkeletonColorOverrideVariant = 'itemPrice' | 'footer';

interface SkeletonLineProps {
  size?: string;
  dataHook?: string;
  className?: string;
  colorOverrideVariant?: SkeletonColorOverrideVariant;
}

export const SkeletonLineWrapper = ({size, dataHook, className, colorOverrideVariant}: SkeletonLineProps) => {
  const {experiments} = useExperiments();
  const ecomCartSkeletonColor = experiments.enabled(SPECS.ecomCartSkeletonColor);

  return (
    <SkeletonLine
      data-hook={dataHook}
      className={st(
        ecomCartSkeletonColor ? classes.root : /* istanbul ignore next */ undefined,
        ecomCartSkeletonColor && colorOverrideVariant
          ? classes[colorOverrideVariant]
          : /* istanbul ignore next */ undefined,
        className ?? classes[size]
      )}
    />
  );
};
